export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const RESUME_API_BASE = process.env.REACT_APP_RESUME_API_BASE;

export const COUNTRIES = 'https://ipapi.co/json/';
export const LOGIN = `${BASE_URL}/user/login`;
export const REGISTER = `${BASE_URL}/user/agency-signup`;
export const FORGOT_PASSWORD = `${BASE_URL}/user/send-forget-pass-mail`;
export const VERIFY_EMAIL_OTP = `${BASE_URL}/user/verify-agency-email`;
export const CHANGE_PASSWORD = `${BASE_URL}/user/verify-forget-pass`;
export const VERIFY_EMAIL_TOKEN = `${BASE_URL}/user/verify-token`;
export const RESEND_EMAIL_OTP = `${BASE_URL}/user/resend-verification-otp`;
export const VERIFY_RECAPCHA = `${BASE_URL}/master/verify-recaptcha`;
export const GET_COUNTRIES_LIST = `${BASE_URL}/master/as-countries`;
export const SAVE_COMPANY_DETAILS = '/agency/save-profile';
export const GET_AGENCY_DETAILS = '/agency/profile';
export const SAVE_TALENT_DETAILS = '/agency/associate-info';
export const GET_TALENT_DETAILS = '/agency/associate-info';
export const GET_LANGUAGES = '/master/languages';
export const GET_INDUSTRIES = '/master/industries';
export const GET_CERTIFICATES = '/master/certificates';
export const GET_TECH_SPHERES = '/master/tech-spheres';
export const GET_LANG_FROM_SPHERES = '/master/lang-from-spheres';
export const GET_FRAMEWORKS_FROM_SPHERES = '/master/framework-from-spheres';
export const GET_FRAMEWORKS = '/master/mt-frameworks';
export const UPLOAD_TALENT_VIDEO = '/agency/associate-video';
export const TALENT_UPLOADED_VIDEO = '/agency/associate-video';
export const GET_TALENTS = '/agency/get-associates';
export const AGENCY_SETUP = '/agency/setup';
export const PUBLISH_OR_UNPUBLISH_TALENT = '/agency/publish-associate';
export const UPDATE_PINNED_OR_UNPINNED_TALENT =
  '/agency/update-pinned-associate';

export const GET_UPLOAD_URL = `${RESUME_API_BASE}/upload-url`;
export const EXTRACT_INFO = `${RESUME_API_BASE}/extract`;
export const TALENT_RESEUME = '/agency/associate-resume';
export const AUTH_GOOGLE = `${BASE_URL}/user/agency-social-login`;
export const AGENCY_COMPLETE_SIGNUP = `${BASE_URL}/user/agency-complete-signup`;
export const VALIDATE_EXISTING_EMAIL = '/user/validate-existing-email';
export const DELETE_AGENCY_MEDIA = '/agency/delete-agency-media';
export const UPLOAD_AGENCY_VIDEO = '/agency/upload-agency-profile-video';
